import { LANG, LANGUAGES } from '@gifsa/language-utils/lang'

export function getActiveLanguages(app?: string): string[] {
  if (app === '@gifsa/call-abroad') {
    return ['en', 'es']
  }
  if (app === '@gifsa/simsurf') {
    return ['en', 'fr', 'de', 'es', 'it', 'pl', 'tr']
  }
  if (app === '@gifsa/skyscanner-simsurf') {
    return ['en', 'es']
  }
  return Object.keys(LANG)
}

export function getLanguageSelections(app?: string) {
  const activated = getActiveLanguages(app)
  return LANGUAGES.filter((l) => activated.includes(l.isoCode))
}
